import { useContext as t } from "react";
import { ComboboxContext as e } from "../contexts/combobox.context.js";
const m = () => {
  const o = t(e);
  if (!o)
    throw new Error("useComboboxContext must be used within a Combobox component");
  return o;
};
export {
  m as useComboboxContext
};
